import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faPaperPlane, faSearch, faVideo } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
const Card = ({ courceName, description, duration, totalVideos }) => {
    return (
        <div>
            <div className='mt-8 w-[400px] h-[317px] border rounded-lg'>
                <img className='rounded-t-lg w-[400px] h-[150px]' src="https://i.pinimg.com/736x/3b/ef/29/3bef29e231df41a3106964aae72c2e88.jpg" />

                <div className='p-3'>
                    <h4>{courceName}</h4>
                    <p className='text-lg font-normal text-black'>{description}</p>
                    <div className="flex gap-4">
                        <p className='font-medium text-gray-500'><FontAwesomeIcon className='mr-1' icon={faClock} />{duration} hours</p>
                        <p className='font-medium text-gray-500'><FontAwesomeIcon className='mr-1' icon={faVideo} />{totalVideos}+ videos</p>
                        <p className='font-medium text-gray-500'><FontAwesomeIcon className='mr-1' icon={faPaperPlane} />Share</p>
                    </div>
                </div>
                <Link to="/guidance-description">
                    <button className='w-full border rounded-b-lg py-2  hover:bg-blue-700 hover:text-white'>Purchanse</button>
                </Link>
            </div>
        </div>
    )
}

export default Card